import { render } from "./CategoriesList.vue?vue&type=template&id=426c7a8a&scoped=true"
import script from "./CategoriesList.vue?vue&type=script&lang=js"
export * from "./CategoriesList.vue?vue&type=script&lang=js"

import "./CategoriesList.vue?vue&type=style&index=0&id=426c7a8a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426c7a8a"]])

export default __exports__